/**
 * TanStack React Query 5 — single client for the whole app.
 *
 * Defaults:
 *   - 30s staleTime so the same query within a tab transition doesn't refetch.
 *   - 5m gcTime so navigation keeps cached data warm.
 *   - retry once for transient 5xx, never for 4xx (handled by the queryFn).
 *
 * Auth (token refresh) and ProblemDetails error mapping land alongside
 * libs/web-shared in Phase 1. Phase 0 is intentionally minimal.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
